$(window).scroll(function () {
  if($(window).scrollTop() > 0) {
    $('#shopify-section-header,.announcement-bar').addClass('fixed');
  } else {
    $('#shopify-section-header,.announcement-bar').removeClass('fixed');
  }
});


/** 文字を分割し、Delayを設定する関数 */
function wordSplitDelay (query, options) {
  options = (function(def){
    var buf = {};
    for (var key in def) {
      if (typeof options !== "object" || !(key in options)) {
        buf[key] = def[key];
        continue;
      }
      buf[key] = options[key];
    }
    return buf;
  })({
    charWrapTag : 'span',        // 文字を囲う要素
    charClass   : 'split_delay', // 文字を囲う要素のclass
    duration    : 1,             // テキスト全体の表示時間(s)
  });

  Array.from(document.querySelectorAll(query)).forEach(function(element){
    // 対象要素直下のテキストノードの一覧を取得する
    var xpathResult = document.evaluate( './text()', element, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
    var textSize = xpathResult.snapshotLength;

    var digit = 2;

    // 文字数取得
    var charSize = 0;
    for (var ii = 0; ii < textSize; ii++ ) {
        charSize+=xpathResult.snapshotItem(ii).textContent.length;
    }
    // 1文字の表示速度を算出
    var charSpeed = parseFloat((options.duration / charSize).toFixed(digit));

    var sumDelay = 0;
    for (var ii = 0; ii < textSize; ii++ ) {
        var textNode   = xpathResult.snapshotItem(ii);
        var parentNode = textNode.parentNode;

        // 1文字ごとにループしてspanを適用する
        var fragment = document.createDocumentFragment();
        textNode.textContent.split('').forEach(function(v){
          var wrap = document.createElement(options.charWrapTag);
          wrap.setAttribute('class', options.charClass);
          wrap.style.transitionDelay = parseFloat((sumDelay).toFixed(digit)) + 's';
          
          wrap.textContent = v;
          fragment.appendChild(wrap);
          // 表示遅延時間を集計
          sumDelay+=charSpeed;
        });

        //要素を書き換える
        parentNode.replaceChild(fragment, textNode);
    }
  });
}

// TOPMVのホバーアニメーション設定
$(function() {
  /*
  $('.top-mv .common .btn').mouseover(function(e) {
    $(this).closest('.common').addClass("hov");
  });
  $('.top-mv .common .btn').mouseout(function(e) {
    $(this).closest('.common').removeClass("hov");
  });
  */

  /*waveフェードインを行う要素の初期化処理を行う*/
  wordSplitDelay('.animation_wavefadein', {
    charWrapTag : 'span',                      // 文字を囲う要素
    charClass   : 'animation_wavefadein_char', // 文字を囲う要素のclass
    duration    : 0.5,                         // テキスト全体の表示時間(s)
  });

  // 遅延表示トリガー
  $("[data-delayTrigger]").each(function(){
    const $delayTrigger = $($(this).attr("data-delayTrigger"));
    if ($delayTrigger[0] === this)return;
    let elements = $delayTrigger.eq(0).data("delayLoadElements");
    if(!elements)elements=[];
    elements.push(this);
    $delayTrigger.eq(0).data("delayLoadElements", elements);
  });

  // 遅延表示トリガーイベント
  function triggerFadeIn (element) {
    ($(element).data("delayLoadElements")||[])
    .forEach(function(delayElement){
      if(!delayElement)return;

      const $delayElement = $(delayElement);
      const delayTime = parseFloat(
        ($delayElement.attr("data-delayTime")||"0")
        .replace(/ms$/, "")
        .replace(/^([\d\.]+)s$/, function(){
          return parseFloat(arguments[1]) * 1000;
        })
      )||0;

      // 指定秒数後に表示
      setTimeout(function(){
        $delayElement.addClass("fadeIn");
        triggerFadeIn(delayElement);
      }, delayTime);
    });
  }

  $('.load').each(function(){
    $(this).on('inview', function(event, isInView, visiblePartX, visiblePartY) {
        if (isInView) {
            if($(this).closest('.swiper-slide:not(.sqiper-slide-duplicate-active,.swiper-slide-active)').length)return;
            $(this).stop().addClass('fadeIn');
            // フェードイン処理発火
            triggerFadeIn(this);
        } else {
            $(this).stop().removeClass('fadeIn');
        }
    })
  });
/*
  // 黒いスクロール表示
  $(window).on('scroll', function(){
    var $element   = $('.site-header figure');
    var bodyRect   = document.body.getBoundingClientRect();
    var pageHeight = window.innerHeight;
    var ratio      = -bodyRect.top/(bodyRect.height - pageHeight);
    $element.height((parseFloat((ratio).toFixed(3)) * 100) + "vh");
  });
*/
});

function openMobileNav() {
  $('.site-header .grid--table').css("background","#e5e5e5")
  $('.site-header').css("border-bottom"," 1px solid #e5e5e5")
  $('.site-header').css("background-color","#e5e5e5")
}

$(function(){
  $('.c-button a').each(function(){
    $(this).mouseover(function(e) {
      $('.js-mv-image').addClass("hov");
    });
    $(this).mouseout(function(e) {
      $('.js-mv-image').removeClass("hov");
    });
  });



  // ヘルプマーククリック
  $(".helpmark").click(function(){
    if($(this).find(".message").length === 0)return;
    if(!window.matchMedia('(max-width: 749px)').matches)return;
    $(this).addClass("popup");
    $(this).addClass("sp"   );
  });

  // ヘルプマークホバー
  $(".helpmark").hover(function(){
    if($(this).find(".message").length === 0)return;
    if(window.matchMedia('(max-width: 749px)').matches)return;
    $(this).addClass("popup");
    $(this).addClass("pc"   );
  }, function(){
    if($(this).find(".message").length === 0)return;
    if(window.matchMedia('(max-width: 749px)').matches)return;
    if(!$(this).hasClass("popup"))return;
    $(this).removeClass("popup");
    $(this).removeClass("pc"   );
  });


  $(".helpmark .close-button").click(function(){
    const $parent = $(this).closest(".helpmark");
    $parent.removeClass("popup");
    $parent.removeClass("pc"   );
    $parent.removeClass("sp"   );
    return false;
  });




  // 商品問い合せボタンクリック時
  $(".message-contact").on("click", function (e) {
    sessionStorage.setItem("product-info",
`${$(".product-single__title").text()}
${$(".product-single__headline p").text()}
カラー：${$("[name=option1]:checked").val()}
数量：${$("#Quantity-product-template").val()}
${location.href}`
    );

    location.href = $(this).attr("href");
    return false;
  });


  // 問い合わせページの
  if (/\/pages\/contact\-delivery/.test(location.href)) {
    $("#ContactForm-content").val(sessionStorage.getItem("product-info"));
  }
});


// Promolayer送信イベント制御
const mapPromolayer = {
  // 3%Offクーポン
  "pLXbqqxhfhWNnsi9S9Zd": {
    promotionText: "3%Off"
  }
};
setInterval(()=>{
  if (!("promolayerObj" in window))return;

  // 送信時イベントを追加
  for (const id of Object.keys(mapPromolayer)) {
    if (!promolayerObj.preloadedDisplays.has(id))continue;
    const el = document.querySelector(`#plmw-${id} form`);
    if (!el)continue;
    if (el.addedEvent)continue;
    el.addedEvent = true;
    el.addEventListener("submit",()=>{
        fbq("trackCustom", "Promolayer", {promotion: mapPromolayer[id].promotionText}, false);
    });
  }


},500);